import { MappingIdentifier } from 'src/containers/ProjectDiagram/types/data';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link Mapping} update `primaryIdentifier`, `sourcePrimaryIdentifier`, and
 * `targetPrimaryIdentifier` fields from @type {(string | null)} to {@link OldMappingIdentifier}
 */
// prevState must be typed as `any` since it's an older version of the Redux State

export const v13 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v13Projects(prevState.projects);
  }

  return nextState;
};

const v13Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    const updatedLinkDataArray = project.diagram.model.linkDataArray.map(
      (linkData) => {
        if (isMapping(linkData)) {
          const {
            primaryIdentifier,
            sourcePrimaryIdentifier,
            targetPrimaryIdentifier,
          } = linkData as any;
          const newPrimaryIdentifier: MappingIdentifier = primaryIdentifier
            ? { baseIri: '', parts: primaryIdentifier }
            : { baseIri: '', parts: [] };
          const newSourcePrimaryIdentifier: MappingIdentifier =
            sourcePrimaryIdentifier
              ? { baseIri: '', parts: sourcePrimaryIdentifier }
              : { baseIri: '', parts: [] };
          const newTargetPrimaryIdentifier: MappingIdentifier =
            targetPrimaryIdentifier
              ? { baseIri: '', parts: targetPrimaryIdentifier }
              : { baseIri: '', parts: [] };
          return {
            ...linkData,
            primaryIdentifier: newPrimaryIdentifier,
            sourcePrimaryIdentifier: newSourcePrimaryIdentifier,
            targetPrimaryIdentifier: newTargetPrimaryIdentifier,
          };
        }
        return linkData;
      }
    );

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          linkDataArray: updatedLinkDataArray,
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
